import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Para redirigir
import { login } from '../services/authService'; // Servicio de autenticación
import 'bootstrap/dist/css/bootstrap.min.css';
import './login.css';
import logoImg from '../images/logo.png';
import logoOmnix from '../images/logoOmnix.png';
import logoOmnixOficial from '../images/logoOmnixOficial.png';

import logo1 from '../images/logosInstituciones/logo1.jpg';
import logo2 from '../images/logosInstituciones/logo2.jpg';
import logo3 from '../images/logosInstituciones/logo3.jpg';
import logo4 from '../images/logosInstituciones/logo4.jpg';
import logo5 from '../images/logosInstituciones/logo5.jpg';

function LoginPage() {
  const logos = [logo1, logo2, logo3, logo4, logo5];

  // Estados para el formulario
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(''); // Estado para errores

  const navigate = useNavigate(); // Para redirigir al dashboard

  const handleSubmit = async (e) => {
    e.preventDefault(); // Evitar recarga del formulario

    try {
      // Llamar al servicio de login
      const userData = await login(email, password);

      // Guardar el usuario en localStorage
      localStorage.setItem('user', JSON.stringify(userData));

      // Redirigir al menú principal
      navigate('/menu');
    } catch (err) {
      // Mostrar mensaje de error
      setError('Credenciales incorrectas');
    }
  };

  return (
    <div>
      {/* Encabezado */}
 <div className="container w-100 text-center">
 <div className="row mt-5 g-2 g-lg-3 align-items-center">
   <div className="col-4">
     <div><img src={logoOmnixOficial} alt="Perfil" height={150} /></div>
   </div>
   <div className="col-8 d-flex align-items-center">
     <h1 className="p-3 texto-principal fw-bold">Bienvenido al Sistema de Información Estadística Infográfica</h1>
   </div>
 </div>
</div>
<hr />

{/* Escudos */}
<div className='d-flex justify-content-center'>
 {logos.map((logo, index) => (
   <img key={index} className='escudoInstitucion mx-2 InstActive' src={logo} alt={`Escudo ${index + 1}`} />
 ))}
</div>
<hr />

{/* Formulario */}
<br /> <br /> <br />
<div className="container d-flex justify-content-center vh-100">
 <div className="card text-center" style={{ width: '25rem', height:'45rem' }}>
   <div className="card-header bg-white border-0">
     <img src={logoOmnixOficial} alt="OMNIX Logo" className="img-fluid mb-2" />
   </div>

   <div className="card-body text-white">
     <form className='formLogin' onSubmit={handleSubmit}>
       <div className="mb-3">
         <div className="input-group">
           <span className="input-group-text">
             <i className="bi bi-person"></i>
           </span>
           <input
             type="email"
             className="form-control"
             placeholder="e-mail / ID"
             value={email}
             onChange={(e) => setEmail(e.target.value)}
             required
           />
         </div>
       </div>
       <br />
       <div className="mb-3">
         <div className="input-group">
           <span className="input-group-text">
             <i className="bi bi-lock"></i>
           </span>
           <input
             type="password"
             className="form-control"
             placeholder="password"
             value={password}
             onChange={(e) => setPassword(e.target.value)}
             required
           />
         </div>
       </div>
       <br />
       {error && <p className="text-danger">{error}</p>} {/* Mostrar errores */}
       <button type="submit" className="btn btn-light w-100">Login</button>
     </form>
   </div>

   <div className="card-footer border-0 small">
     <p style={{color:'black'}}>
       "OMNIX es propiedad intelectual exclusiva, con todos los derechos reservados, conforme a las disposiciones legales aplicables."
     </p>
     <a href="#" className="aviso">Aviso de privacidad</a>
   </div>
 </div>
</div>
</div>
  );
}

export default LoginPage;



 